<!-- <app-data-table [columns]="cols" [data]="schemes" [title]="title"></app-data-table> -->

<div class="min-h-screen bg-slate-50 p-2 md:p-4 font-sans">

  <!-- Header Section -->
  <div class="mb-2 flex items-center justify-between gap-2 bg-gradient-to-r from-blue-500 to-blue-700 p-2 md:p-4 rounded-lg shadow-lg border border-blue-500">
    <div class="flex items-center gap-2">
      <div class="flex h-8 w-8 items-center justify-center rounded-md bg-white text-blue-700 border border-blue-200 shadow">
        <i class="pi pi-sitemap text-base"></i>
      </div>
      <div>
        <h1 class="text-base md:text-lg font-bold text-white leading-4">Schemes Master</h1>
        <p class="text-[9px] text-blue-100 hidden md:block">Manage schemes, sub-schemes &amp; phase timelines</p>
      </div>
    </div>
    <button
      class="inline-flex items-center justify-center gap-1 rounded bg-amber-400 hover:bg-amber-500 px-3 py-1 text-xs font-semibold text-blue-700 shadow transition-all border border-white"
      (click)="onAdd()"
      *ngIf="'/master/scheme' | hasPermission: 'Add'">
      <i class="pi pi-plus"></i>
      <span class="hidden sm:inline">Add Scheme</span>
    </button>
  </div>

  <!-- Schemes List -->
  <div class="space-y-2">
    <div
      *ngFor="let scheme of schemes"
      class="group overflow-hidden rounded-lg border border-blue-100 bg-white shadow hover:shadow-md transition-all">

      <!-- Scheme Header -->
      <div
        (click)="toggleScheme(scheme.id, $event)"
        class="flex cursor-pointer items-center justify-between py-2 px-3 hover:bg-blue-50 transition-colors">

        <div class="flex items-center gap-2 min-w-0 flex-1">
          <div class="h-1 w-3 rounded bg-blue-600"></div>
          <span class="text-sm font-semibold text-blue-900 truncate max-w-xs">{{ scheme.name }}</span>
          <span class="text-[9px] text-blue-400 truncate max-w-[10rem] ml-2 hidden md:inline">{{ scheme.description || 'No description' }}</span>
        </div>

        <div class="flex items-center gap-1">
          <span
            *ngIf="scheme.name != 'IDEX'"
            class="hidden sm:inline-block rounded bg-blue-50 px-1 py-0.5 text-[9px] font-semibold text-blue-700 border border-blue-100">
            {{scheme.phase.length}} Ph
          </span>

          <button
            class="h-6 w-6 flex items-center justify-center rounded text-blue-400 bg-blue-50 hover:bg-blue-100 hover:text-blue-600 transition-all"
            (click)="onAddSubscheme(scheme); $event.stopPropagation()" pTooltip="Add Sub Scheme">
            <i class="pi pi-plus text-xs" *ngIf="'/master/scheme' | hasPermission: 'Edit'"></i>
          </button>
          <button
            class="h-6 w-6 flex items-center justify-center rounded text-amber-500 bg-amber-50 hover:bg-amber-100 hover:text-amber-600 transition-all"
            (click)="onEdit(scheme); $event.stopPropagation()" pTooltip="Edit">
            <i class="pi pi-pencil text-xs" *ngIf="'/master/scheme' | hasPermission: 'Edit'"></i>
          </button>
          <button
            class="h-6 w-6 flex items-center justify-center rounded text-indigo-400 bg-indigo-50 hover:bg-indigo-100 hover:text-indigo-600 transition-all"
            (click)="fileList(scheme); $event.stopPropagation()" pTooltip="Files">
            <i class="pi pi-file text-xs"></i>
          </button>
          <button
            class="h-6 w-6 flex items-center justify-center rounded text-blue-500 hover:bg-blue-100 transition-transform duration-200"
            [class.rotate-180]="isSchemeExpanded(scheme.id)">
            <i class="pi pi-chevron-down text-xs"></i>
          </button>
        </div>
      </div>

      <!-- Scheme Expanded Content -->
      <div class="border-t border-blue-50 bg-blue-50/30 px-2 py-2" *ngIf="isSchemeExpanded(scheme.id)">

        <!-- With Sub Schemes -->
        <ng-container *ngIf="sub_schemes?.length > 0; else noSubSchemes">
          <div class="space-y-1.5">
            <div *ngFor="let subScheme of sub_schemes" class="rounded border border-slate-200 bg-white shadow-sm">

              <!-- Sub Scheme Header -->
              <div
                (click)="toggleScheme(subScheme.id, $event, true)"
                class="flex items-center justify-between cursor-pointer px-2 py-1 hover:bg-blue-50 border-b border-slate-100">

                <div class="flex items-center gap-2 overflow-hidden">
                  <div class="h-1 w-3 bg-blue-200 rounded"></div>
                  <span class="text-[13px] font-bold text-blue-700 truncate">{{ subScheme.name }}</span>
                  <span class="rounded bg-slate-100 px-1.5 py-0.5 text-xs font-medium text-blue-700 ml-1">{{ subScheme.phase?.length || 0 }} Ph</span>
                </div>
                <div class="flex items-center gap-1">
                  <button
                    class="h-6 w-6 rounded text-red-500 bg-red-50 hover:bg-red-100 transition-all"
                    (click)="onshowDeleteDialog(subScheme.id); $event.stopPropagation()">
                    <i class="pi pi-trash text-xs" *ngIf="'/master/scheme' | hasPermission: 'Delete'"></i>
                  </button>
                  <button
                    class="h-6 w-6 rounded text-blue-600 bg-blue-50 hover:bg-blue-100 transition-all"
                    (click)="onEdit(subScheme); $event.stopPropagation()">
                    <i class="pi pi-pencil text-xs" *ngIf="'/master/scheme' | hasPermission: 'Edit'"></i>
                  </button>
                  <button
                    class="h-6 w-6 rounded text-blue-500 hover:bg-blue-100 transition duration-200"
                    [class.rotate-180]="isSubSchemeExpanded(subScheme.id)">
                    <i class="pi pi-chevron-down text-xs"></i>
                  </button>
                </div>
              </div>

              <!-- Sub Scheme Phases -->
              <div class="px-2 py-1 border-t border-slate-100 bg-slate-50/40" *ngIf="isSubSchemeExpanded(subScheme.id)">
                <div class="space-y-1">
                  <div *ngFor="let phase of mapped_phases" class="rounded border border-slate-100 bg-white">

                    <!-- Phase Header -->
                    <div class="flex items-center justify-between px-2 py-1 cursor-pointer border-b border-slate-50 hover:bg-blue-50"
                      (click)="togglePhase(subScheme.id, phase.id)">
                      <h5 class="text-xs font-bold text-blue-800 uppercase tracking-wide">{{ phase.name }}</h5>
                      <div class="flex items-center gap-1">
                        <button class="text-xs font-bold text-amber-600 bg-amber-100 px-2 py-[1px] rounded hover:bg-amber-200 transition-colors"
                          *ngIf="'/master/scheme' | hasPermission: 'Add'"
                          (click)="onAddStape(subScheme, subScheme.name, phase); $event.stopPropagation()">+ Step</button>
                        <i class="pi pi-chevron-down text-xs text-blue-400 transition-transform duration-200"
                          [class.rotate-180]="isPhaseExpanded(subScheme.id, phase.id)"></i>
                      </div>
                    </div>

                    <!-- Phase Steps -->
                    <div class="p-2 space-y-1 border-t border-slate-100 bg-slate-50" *ngIf="isPhaseExpanded(subScheme.id, phase.id)">
                      <div *ngIf="getPhaseSteps(phase.id).length === 0" class="py-2 text-center text-blue-300 text-xs">
                        <i class="pi pi-info-circle mr-1"></i> No steps added
                      </div>
                      <div *ngFor="let stage of getPhaseSteps(phase.id)"
                        class="flex items-center gap-2 rounded border border-slate-100 bg-white px-2 py-1 text-xs hover:border-blue-300 transition-colors group/step">
                        <span class="shrink-0 text-[9px] font-bold bg-blue-700 text-white px-1.5 py-0.5 rounded">S{{ stage.sequence }}</span>
                        <span class="font-semibold text-blue-800 truncate flex-1">{{ stage.step.name }}</span>
                        <span class="text-slate-500 font-medium">Wk:</span><span class="text-blue-800 font-bold">{{ stage.week_timeline }}</span>
                        <span class="text-slate-500 font-medium">%</span><span class="text-amber-600 font-bold">{{ stage.percentage }}</span>
                        <button class="text-blue-200 hover:text-red-600 p-0.5 transition-colors"
                          (click)="onDeleteStage(stage, subScheme.id); $event.stopPropagation()">
                          <i class="pi pi-trash text-xs"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- No Sub Schemes - Direct Phases -->
        <ng-template #noSubSchemes>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            <div *ngFor="let phase of mapped_phases" class="flex flex-col rounded border border-blue-100 bg-white shadow-sm">

              <!-- Phase Header -->
              <div (click)="togglePhase(scheme.id, phase.id)"
                class="flex cursor-pointer items-center justify-between bg-blue-50 p-2 border-b border-blue-100 hover:bg-blue-100">
                <h5 class="text-xs font-semibold text-blue-800 uppercase tracking-wide">{{ phase.name }}</h5>
                <div class="flex items-center gap-1">
                  <button class="text-xs font-bold text-amber-600 bg-amber-100 px-2 py-[1px] rounded hover:bg-amber-200 transition-colors"
                    *ngIf="'/master/scheme' | hasPermission: 'Add'"
                    (click)="onAddStape(scheme, scheme.name, phase); $event.stopPropagation()">+ Step</button>
                  <i class="pi pi-chevron-down text-xs text-blue-400 transition-transform duration-200"
                    [class.rotate-180]="isPhaseExpanded(scheme.id, phase.id)"></i>
                </div>
              </div>

              <!-- Phase Steps -->
              <div class="p-2 bg-blue-50 space-y-1" *ngIf="isPhaseExpanded(scheme.id, phase.id)">
                <div *ngIf="getPhaseSteps(phase.id).length === 0" class="py-2 text-center text-blue-300 text-xs">
                  <i class="pi pi-info-circle mr-1"></i> No steps
                </div>
                <div *ngFor="let stage of getPhaseSteps(phase.id)" class="group/step relative rounded border border-blue-100 p-2 bg-white hover:border-blue-300 transition-colors">
                  <div class="flex justify-between items-center gap-2">
                    <div class="min-w-0 flex-1">
                      <span class="text-[9px] text-blue-300 uppercase font-medium">Step {{ stage.sequence }}</span>
                      <span class="text-xs font-bold text-blue-700 block truncate">{{ stage.step.name }}</span>
                    </div>
                    <span class="text-xs text-blue-800 font-bold">{{ stage.week_timeline }}w</span>
                    <span class="text-xs text-amber-600 font-bold">{{ stage.percentage }}%</span>
                    <button class="opacity-0 group-hover/step:opacity-100 text-blue-200 hover:text-red-600 transition-all p-0.5"
                      (click)="onDeleteStage(stage, scheme.id); $event.stopPropagation()">
                      <i class="pi pi-trash text-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>



<p-dialog header="Scheme Details" [(visible)]="displayDialog" [modal]="true" [draggable]="false" [resizable]="true"
  [maximizable]="true" [closable]="true" [style]="{width: '50vw'}" class="add-scheme-dialog">
  <form [formGroup]="schemeForm">
    <div class="row mt-3 mb-3">
      <div class="col-md-6 mt-3 mb-3">
        <label for="schemeName" class="form-label">Scheme Name <b class="text-danger">*</b></label>
        <input pInputText id="schemeName" class="w-100" formControlName="name" autocomplete="off" maxlength="100" />
        <div *ngIf="schemeForm.get('name')?.touched && schemeForm.get('name')?.invalid" class="text-danger mt-1">
          <div *ngIf="schemeForm.get('name')?.errors?.['required']">
            Scheme Name is required.
          </div>
          <div *ngIf="schemeForm.get('name')?.errors?.['pattern']">
            Only alphabets and spaces are allowed.
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3 mb-3">
        <label for="schemeCode" class="form-label">Scheme Code <b class="text-danger">*</b></label>
        <input pInputText id="schemeCode" class="w-100" formControlName="code" autocomplete="off" maxlength="50" />
        <div *ngIf="schemeForm.get('code')?.touched && schemeForm.get('code')?.invalid" class="text-danger mt-1">
          <div *ngIf="schemeForm.get('code')?.errors?.['required']">
            Scheme Code is required.
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-3 mb-3">
        <label for="phases" class="form-label">Phases</label>
        <p-multiSelect id="phases" formControlName="phases" [options]="schemePhase" optionLabel="name" optionValue="id"
          display="chip" [showToggleAll]="true" appendTo="body" class="w-100">
        </p-multiSelect>
        <div class="text-danger mt-1"
          *ngIf="schemeForm.get('phases')?.touched && schemeForm.get('phases')?.hasError('required')">
          At least one phase is required.
        </div>
      </div>
      <div class="col-md-12  mt-3 mb-3" *ngIf="addSub">
        <label class="ps-2" for="scheme">Select Scheme <b class="text-danger">*</b></label>
        <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true" filterBy="name"
          optionLabel="name" placeholder="Select Scheme" [style]="{ 'width': '100%' }" optionValue="id">
        </p-dropdown>
        <div class="text-danger mb-3" *ngIf="schemeForm.get('scheme')?.invalid && schemeForm.get('scheme')?.touched">
          Scheme selection is required
        </div>
      </div>

      <div class="col-md-12 mt-3 mb-3">
        <label for="description" class="form-label">Description <b class="text-danger">*</b></label>
        <textarea pInputTextarea id="description" rows="5" class="w-100" formControlName="description"
          autocomplete="off"></textarea>
        <div *ngIf="schemeForm.get('description')?.touched && schemeForm.get('description')?.invalid"
          class="text-danger mt-1">
          <div *ngIf="schemeForm.get('description')?.errors?.['required']">
            Description is required.
          </div>
        </div>
      </div>
      <!-- <div class="col-md-12">
        <div class="card">
          <p-fileUpload name="demo[]" #fileUpload [customUpload]="true" (uploadHandler)="onFileChange($event)"
            [multiple]="true" [auto]="true" mode="advanced" [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
            [maxFileSize]="209715200" required>
            <ng-template #empty>
              <div>Choose a file to Upload</div>
            </ng-template>

          </p-fileUpload>
        </div>
      </div> -->
      <app-upload-document></app-upload-document>
      <div *ngIf="selectedScheme?.files?.length > 0" class="stages-list mt-3">
        <div class="stage-item" *ngFor="let file of selectedScheme.files">
          <div class="stage-header row">

            <div class="col-md-9">
              <h6>{{getTheName(file.file)}}</h6>
            </div>
            <div class="col-md-3 d-flex justify-content-end align-items-center gap-3 mb-2">
              <!-- <span> <i class="pi pi-trash bg-danger text-white p-2 rounded"></i></span> -->
              <span class="d-flex gap-2 pi pi-download bg-secondary text-white p-2 rounded"
                (click)="download(file.file)"> Download </span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </form>

  <footer class="d-flex justify-content-end mt-5 gap-3">
    <button type="submit" class="btn btn-primary me-2" [disabled]="schemeForm.invalid "
      (click)="onSave()">Submit</button>
  </footer>
</p-dialog>



<ng-container *ngIf="isFilepopup">
  <p-dialog header="Uploaded File{{selectedScheme.name}}" [(visible)]="isFilepopup" [modal]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [closable]="true" [style]="{width: '50vw'}">

    <div *ngIf="selectedScheme?.files?.length > 0" class="stages-list mt-3">
      <div class="stage-item" *ngFor="let file of selectedScheme.files">
        <div class="stage-header row">

          <div class="col-md-9">
            <h6>{{getTheName(file.file)}}</h6>
          </div>
          <div class="col-md-3 d-flex justify-content-end align-items-center gap-3 mb-2">
            <!-- <span> <i class="pi pi-trash bg-danger text-white p-2 rounded"></i></span> -->
            <span class="d-flex gap-2 pi pi-download bg-secondary text-white p-2 rounded" (click)="download(file.file)">
              Download </span>
            <!-- <span class="bg-light border text-white p-2 rounded" > <a href="{{ url + file.file}}" target="_blank" class="text-dark" rel="noopener noreferrer"> <i class="pi pi-download">save </i> </a></span> -->

          </div>
        </div>

      </div>
    </div>
    <div *ngIf="selectedScheme?.files?.length == 0"
      class="stages-list mt-3 d-flex justify-content-center align-items-center">
      <h4>No files found.</h4>
    </div>
    <!-- <footer class="d-flex justify-content-end mt-5 gap-3">
    <p-button label="Cancel" [outlined]="true" icon="pi pi-times" severity="danger" (click)="isFilepopup=false"></p-button>
  </footer> -->

  </p-dialog>
</ng-container>

<p-dialog header="Add Steps to {{selectedSchemeName}}" [(visible)]="displayStapeDialog" [modal]="true"
  [draggable]="false" [resizable]="true" [closable]="true" [style]="{width: '80vw' , height: '600px'}"
  [maximizable]="true">
  <form [formGroup]="stapeForm">

    <!-- Existing form controls remain the same -->
    <div class="flex  gap-4 mt-3 mb-5">
      <div class="w-1/2 flex flex-row justify-between items-center gap-4">

        <label for="schemeName" class="font-medium mb-1 w-25">Phase <b class="text-red-500">*</b></label>
        <div class="w-75">
          <p-dropdown 
            id="schemeName"
            [filter]="true" 
            filterBy="name" 
            formControlName="phase"
            [options]="mapped_phases"
            (onChange)="onPhaseChanged($event.value)"
            optionLabel="name"
            optionValue="id"
            placeholder="Select Phase"
            appendTo="body" 
            styleClass="w-full"
            [disabled]="true"
            [ngClass]="{ 'opacity-50 cursor-not-allowed': stapeForm.get('phase')?.disabled }">
          </p-dropdown>
        </div>
      </div>
      <div class="w-1/2 flex flex-row justify-between items-center gap-4">
        <label class="mb-1 block w-25">Phase Sequence</label>
        <input 
          type="text"
          class="p-inputtext w-75 border-2 border-gray-300  px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
          maxlength="2"
          minlength="1"
          (keypress)="allowOnlyNumbers($event)"
          formControlName="phase_sequence"
        />
      </div>
    </div>
    <div class="d-flex mt-3 mb-5 flex-column">
      <label for="schemeName">Step Name <b class="text-danger">*</b></label>
      <div class="d-flex justify-content-between">
        <p-multiSelect id="schemeName" [filter]="true" filterBy="name" formControlName="name" [options]="filteredStages"
          optionLabel="name" optionValue="id" placeholder="Select Step Name" display="chip" [showToggleAll]="true"
          appendTo="body" pSize="large" [maxSelectedLabels]="50" (onChange)="onStagesChanged($event)" class="col-md-8">
        </p-multiSelect>
        <div class="d-flex justify-content-end">
          <button pButton type="button" label="Add to Step List" (click)="addToTimeline()" class="fetch-data-btn"
            [disabled]="selectedStageIds?.length < 1"></button>
        </div>
      </div>
    </div>

    <!-- Timeline Table with added columns -->
    <p *ngIf="addtoTimelineClicked || timelineStages.length > 0" class="mt-3 mb-2"><b>Drag and drop steps to change
        the sequence and submit</b></p>

    <div cdkDropList (cdkDropListDropped)="drop($event)">
      <p-table [value]="timelineStages" class="timeline-table">
        <ng-template pTemplate="header">
          <tr>
            <th></th> <!-- Drag Icon Column -->
            <th>#</th>
            <th>Step Name</th>
            <th>Timeline (Weeks)</th>
            <th>Percentage (%)</th>
            <th>Action</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-stage let-i="rowIndex">
          <tr cdkDrag>
            <!-- Drag Handle Column -->
            <td class="drag-handle-cell">
              <span class="pi pi-bars drag-handle" cdkDragHandle></span>
            </td>

            <td>{{ i + 1 }}</td>
            <td>{{ stage.name }}</td>
            <td>
              <input type="number" pInputText [(ngModel)]="stage.week_timeline" min="1"
                (ngModelChange)="validatePercentage()" [ngModelOptions]="{standalone: true}" class="w-100"
                placeholder="Optional (e.g. 20)">
            </td>
            <td>
              <input type="number" pInputText [(ngModel)]="stage.percentage" min="0" max="100"
                (ngModelChange)="validatePercentage()" [ngModelOptions]="{standalone: true}" class="w-100"
                placeholder="Optional (e.g. 2)">
            </td>
            <td>
              <button type="button" (click)="removeFromTimeline(stage.id)" pButton icon="pi pi-times" class="times"
                [style.fontSize.px]="14">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Validation message -->
    <div *ngIf="timelineStages.length > 0" class="p-message p-message-error mt-2"
      [hidden]="totalPercentage === 100 || totalPercentage === 0 ">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Total percentage must be exactly 100%.
        Current total: {{totalPercentage}}%
      </span>
    </div>

  </form>

  <footer class="d-flex justify-content-end mt-4 gap-3" *ngIf="timelineStages.length > 0">
    <p-button label="Submit" [outlined]="true" icon="pi pi-check" (click)="onSaveStape()"></p-button>
  </footer>
</p-dialog>




<p-dialog header="Delete Scheme" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
  [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete scheme ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="onDelete()" class="mt-2">
    </p-button>
  </div>
</p-dialog>

<p-dialog header="Delete Scheme Stage" [modal]="true" [(visible)]="deleteStepPopup" [style]="{ width: '30rem' }">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete stage ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDeleteStage()"
      class="mt-2">
    </p-button>
  </div>
</p-dialog>